import { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import { getFormErrorMessage, classNames, isFormFieldValid } from "../../../../config/global";
import { SelectButton } from "primereact/selectbutton";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import CardSeplag from "../../../../components/CardSeplag";
import ModalSeplag from "../../../../components/ModalSeplag";
import RotuloSeplag from "../../../../components/RotuloSeplag";
import {
  atualizarCronogramaRag,
  createCronogramaRag,
  cronogramaAllFase,
  excluirCronogramaRag,
} from "../../../../service/Rag/Exercicio";

const ModalRagCronograma = ({
  cronograma,
  exercicio,
  visible,
  setAtualizaList,
  setVisible,
  edit,
  setEdit,
  setDisabled,
  disabled,
}) => {
  const [form, setForm] = useState({
    exercicio: exercicio.exercicio,
    ...cronograma,
  });

  const [listaFase, setListaFase] = useState([]);
  const toast = useRef(null);

  const options = [
    { name: "Ação", code: "A" },
    { name: "Indicador", code: "I" },
    { name: "Programa", code: "P" },
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,

    validate: (data) => {
      let errors = {};
      if (!data.descCronograma) errors.descCronograma = "Selecione descrição é Obrigatório";
      if (!data.tipoItemRag) errors.tipoItemRag = "Items do período do rag é Obrigatório";
      if (!data.dataFinal) errors.dataFinal = "Data Inicial é Obrigatório";
      if (!data.dataFinal) errors.dataFinal = "Data Final é Obrigatório";
      if (!data.dataInicial) errors.dataInicial = "Data Inicial é Obrigatório";
      if (!data.fase) errors.fase = "Selecione a fase do rag é Obrigatório";
      return errors;
    },

    onSubmit: async (data) => {
      let cronogramaData = {
        fase: data.fase,
        parametroExercicioRag: {
          idenParametroExercicio: exercicio.idenParametroExercicio,
          exercicio: exercicio.exercicio,
          contaAcesso: exercicio.contaAcesso,
          flagAtivo: exercicio.flagAtivo,
          flagFechadoEdicao: exercicio.flagFechadoEdicao,
          dataInclusao: exercicio.dataInclusao,
          statParametroExercicio: exercicio.statParametroExercicio,
          cronograma: [],
        },
        dataInicial: data.dataInicial,
        dataFinal: data.dataFinal,
        descCronograma: data.descCronograma,
        tipoItemRag: data.tipoItemRag,
        statCronograma: 1,
      };
      if (edit) {
        await atualizarCronogramaRag(cronograma.idenCronograma, cronogramaData).then((_res) => {
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });

          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizaList(true);
        });
      }
      if (!edit) {
        await createCronogramaRag(cronogramaData).then((_res) => {
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizaList(true);
        });
      }
    },
  });

  const handleExit = () => {
    setVisible(false);
    setEdit(false);
    setDisabled(false);
  };

  const deleteCronograma = async (event) => {
    event.preventDefault();
    await excluirCronogramaRag(cronograma.idenCronograma).then((_res) => {
      window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
      setVisible(false);
      setEdit(false);
      setDisabled(false);
      setAtualizaList(true);
    });
  };

  useEffect(() => {
    cronogramaAllFase().then((res) => {
      setListaFase(res.data);
    });
  }, []);

  return (
    <ModalSeplag
      titulo="Cadastrar/Cronograma"
      tamanho="1200px"
      type="NONE"
      visible={visible}
      fechar={() => {
        setVisible(false);
        setEdit(false);
        setDisabled(false);
      }}
    >
      <Toast ref={toast} />
      <CardSeplag>
        <form>
          <div className="field col-12 md:col-12 ">
            <div className="p-fluid grid">
              <div className="field col-12 md:col-6">
                <RotuloSeplag nome="Exercicio RAG" cols="12 4">
                  <InputText
                    disabled={true}
                    id="ano"
                    name="ano"
                    value={formik.values.exercicio?.ano}
                    onChange={(e) => formik.handleChange(e)}
                  />
                </RotuloSeplag>
              </div>
              <div className="field col-12 md:col-4">
                <span>
                  <RotuloSeplag obrigatorio nome={"Fase RAG:"} cols="12 4">
                    <Dropdown
                      placeholder="Selecione a Fase"
                      id="fase"
                      name="fase"
                      optionLabel="descFase"
                      disabled={disabled}
                      value={formik.values.fase}
                      options={listaFase}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      className={classNames({ "p-invalid": isFormFieldValid("fase", formik) })}
                    />
                    {getFormErrorMessage("fase", formik)}
                  </RotuloSeplag>
                </span>
              </div>
              <div className="field col-12 md:col-12 ">
                <div className="p-fluid grid line-height-6">
                  <div className="field col-12 md:col-6">
                    <span>
                      <RotuloSeplag obrigatorio nome="Descrição Cronograma Rag" cols="12 4">
                        <InputText
                          disabled={disabled}
                          id="descCronograma"
                          name="descCronograma"
                          options={options}
                          value={formik.values.descCronograma}
                          onChange={(e) => formik.handleChange(e)}
                          className={classNames({ "p-invalid": isFormFieldValid("descCronograma", formik) })}
                        />
                        {getFormErrorMessage("descCronograma", formik)}
                      </RotuloSeplag>
                    </span>
                  </div>
                </div>
              </div>
              <hr style={{ width: "100%", margin: "2% 1%", height: "1px" }} />
              <div className="field col-12 md:col-12 ">
                <div className="p-fluid grid">
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Data Inicial:" cols="12 4">
                      <InputMask
                        disabled={disabled}
                        mask="99/99/9999"
                        id="dataInicial"
                        name="dataInicial"
                        value={formik.values?.dataInicial}
                        onChange={formik.handleChange}
                      />
                      {getFormErrorMessage("dataInicial", formik)}
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Data Final:" cols="12 3">
                      <InputMask
                        disabled={disabled}
                        mask="99/99/9999"
                        id="dataFinal"
                        name="dataFinal"
                        value={formik.values?.dataFinal}
                        onChange={formik.handleChange}
                      />
                      {getFormErrorMessage("dataFinal", formik)}
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Marque os itens para o Periodo RAG" cols="12 4">
                      <SelectButton
                        disabled={disabled}
                        id="tipoItemRag"
                        optionLabel="name"
                        optionValue="code"
                        options={options}
                        value={formik.values?.tipoItemRag}
                        onChange={(e) => formik.handleChange(e)}
                      />
                      {getFormErrorMessage("tipoItemRag", formik)}
                    </RotuloSeplag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!disabled && (
            <div className="field col-12 md:col-12 ">
              <div className="p-fluid grid">
                <div className="field col-12 md:col-3 ">
                  <Button label="Fechar" className="voltar p-button-danger" onClick={handleExit} />
                </div>

                <div className="field col-12 md:col-4">
                  {!edit && <Button type="submit" label="Cadastrar" className="salvar" onClick={formik.handleSubmit} />}
                  {edit && <Button type="submit" label="Salvar" className="salvar" onClick={formik.handleSubmit} />}
                </div>
                <div className="field col-12 md:col-4">
                  {edit && <Button label="Excluir" className="voltar p-button-danger" onClick={deleteCronograma} />}
                </div>
              </div>
            </div>
          )}
        </form>
      </CardSeplag>
    </ModalSeplag>
  );
};
export default ModalRagCronograma;
